/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Group_To_JsonInputs */

const en_sidebar_group_to_json = /** @type {(inputs: Sidebar_Group_To_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To JSON`)
};

const ko_sidebar_group_to_json = /** @type {(inputs: Sidebar_Group_To_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON으로 변환`)
};

const ja_sidebar_group_to_json = /** @type {(inputs: Sidebar_Group_To_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONへ変換`)
};

/**
* | output |
* | --- |
* | "To JSON" |
*
* @param {Sidebar_Group_To_JsonInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_group_to_json = /** @type {((inputs?: Sidebar_Group_To_JsonInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Group_To_JsonInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_group_to_json(inputs)
	if (locale === "ko") return ko_sidebar_group_to_json(inputs)
	return ja_sidebar_group_to_json(inputs)
});